import React from 'react';
import { styled } from '@material-ui/core';
import { ReactComponent as ErrorOutline } from 'assets/icons/error-outline.svg';
import { ReactComponent as Tick } from 'assets/icons/tick.svg';

export const RootComponent = styled('div')({
  width: '100%',
});

const getBorderColour = (state, theme) => {
  switch (state) {
    case 'verified':
      return theme.palette.common.success;
    case 'error':
      return theme.palette.common.error;
    default:
      return theme.palette.xpl.stoke;
  }
};

export const InputWrapper = styled('div')(({ state, theme, focused }) => {
  return {
    display: 'flex',
    width: '100%',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    border: '1px solid',
    borderColor:
      !state && focused
        ? theme.palette.xpl.secondary.default
        : getBorderColour(state, theme),
    borderRadius: '4px',
    overflow: 'hidden',
    '&:hover': {
      borderColor: !state
        ? theme.palette.xpl.secondary.default
        : getBorderColour(state, theme),
    },
    '&[disabled]': {
      borderColor: theme.palette.xpl.stoke,
      color: theme.palette.xpl.text.secondary,
      backgroundColor: theme.palette.xpl.background2,
      pointerEvents: 'none',
      '&:hover': {},
    },
  };
});

export const InputContainer = styled('div')({
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'stretch',
  flex: '1 1 auto',
});

export const InlineIcon = styled('div')({
  position: 'absolute',
  top: '50%',
  width: '15px',
  height: '15px',
  right: 0,
  marginRight: '15px',
  transform: 'translate(0, -50%)',
  pointerEvents: 'none',
});

export const ErrorIcon = styled((props) => (
  <InlineIcon {...props} component={ErrorOutline} />
))(({ theme }) => ({
  width: '15px',
  height: '15px',
  color: theme.palette.common.error,
}));

export const VerifiedIcon = styled((props) => (
  <InlineIcon {...props} component={Tick} />
))(({ theme }) => ({
  color: theme.palette.common.success,
}));

const getCommonInputStyles = (theme) => ({
  cursor: 'text',
  fontFamily: 'inherit',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '0px',
  textAlign: 'left',
  border: 0,
  outline: 'none',
  maxWidth: '100%',
  width: '100%',
  minWidth: 0,
  '&::placeholder': {
    color: theme.palette.xpl.text.secondary,
  },
  '&:disabled': {
    backgroundColor: theme.palette.xpl.action.disabled,
    color: theme.palette.xpl.text.secondary,
    '&:hover': {},
  },
});

export const BaseInput = styled('textarea')(({ resizeable, theme }) => {
  return {
    ...getCommonInputStyles(theme),
    padding: '10px 15px',
    resize: resizeable ? 'vertical' : 'none',
    color: theme.palette.xpl.text.primary,
  };
});
